// ======================
// IMPORTS
// ======================
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// Setup methods
import setupIcons from './setup/icons'
import setupVue from './setup/vue'
import setupJQuery from './setup/jquery'
import i18n from './setup/internationalization'

// ======================
// MAIN SETUP
// ======================
setupJQuery()

setupVue(Vue)

setupIcons()

new Vue({
    router,
    store,
    i18n,
    render: (h) => h(App),
}).$mount('#app')
